import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	/* webpackChunkName: "PurchaseConditionDashboardPage" */
	'pages/supplier/PurchaseCondition/PurchaseConditionDashboardPage'));

export default [{ component, exact: true, path: '/purchase_conditions/:purchaseConditionId' }];